<h1 class="title" translate>HOMEPAGE.PIN.TITLE</h1>
<app-page-wrapper>
  <div class="card-container">
    <div class="ic1-my-12">
      <ng-ui-kit-toast
        *ngIf="showSuccess"
        status="success"
        [text]="'PIN_PAGE.SUCCESS' | translate">
      </ng-ui-kit-toast>
    </div>
    <ng-ui-kit-card
      id="pin-card"
      type="summative"
      [title]="'PIN_PAGE.CARD.TITLE' | translate"
      [text]="'PIN_PAGE.CARD.DESC' | translate"
      [attr.translate-key]="
        'PIN_PAGE.CARD.TITLE,PIN_PAGE.CARD.DESC,PIN_PAGE.CARD.ACTION'
      "
      [button]="cardButton">
    </ng-ui-kit-card>
  </div>
</app-page-wrapper>

<app-common-modal
  modalId="pin-modal"
  [title]="'PIN_PAGE.CARD.TITLE' | translate"
  [(visible)]="pinModalVisible"
  [config]="{ size: 'lg', persistent: true, hideButtons: true }"
  (onClose)="onTogglePinModal(false)">
  <ng-container *ngIf="renderPinModalContent">
    <form
      [formGroup]="form"
      *ngIf="showStep1 || showStep2"
      (ngSubmit)="onSubmit()">
    <!-- FIRST STEP START -->
    <div class="ic1-mt-24">
      <ng-ui-kit-accordion
        class="step1"
        [attr.translate-key]="'PIN_PAGE.ACCORDION.FIRST_STEP.TITLE'"
        [disabled]="showStep2"
        [title]="'PIN_PAGE.ACCORDION.FIRST_STEP.TITLE' | translate"
        [icon]="showStep2 ? 'check' : ''"
        [open]="showStep1"
        [step]="!showStep2 ? 1 : 0">
        <ng-container content>
          <div class="ic1-row">
            <div class="ic1-col-12 desc" translate>PIN_PAGE.CARD.DESC</div>
            <ng-ui-kit-toast
              class="ic1-col-12 ic1-my-12"
              status="warning"
              [text]="'PIN_PAGE.ACCORDION.FIRST_STEP.MESSAGE' | translate">
            </ng-ui-kit-toast>
            <ng-ui-kit-toast
              *ngIf="showPinInfo"
              class="ic1-col-12 ic1-mb-12"
              status="info"
              [text]="'PIN_PAGE.INFO' | translate">
            </ng-ui-kit-toast>

            <!-- FORM FOR FIRST STEP START -->

            <div class="ic1-col-12">
              <ng-ui-kit-input
                formControlName="oldPin"
                name="oldPin"
                autocomplete="oldPin"
                [placeholder]="
                  'PIN_PAGE.ACCORDION.FIRST_STEP.ACTUAL_PIN_PLACEHOLDER'
                    | translate
                "
                type="password"
                icName="oldPin"
                icId="oldPin"
                [maxlength]="8"
                [OnlyNumbers]="8"
                [label]="
                  'PIN_PAGE.ACCORDION.FIRST_STEP.ACTUAL_PIN_LABEL' | translate
                "
                [status]="
                  step1Attempted && oldPin.invalid
                    ? 'error'
                    : 'informative'
                ">
              </ng-ui-kit-input>
              <app-field-validator
                *ngIf="step1Attempted"
                [field]="oldPin"
                [formErrors]="formErrors"></app-field-validator>
            </div>
            <div class="w-100"></div>
            <div class="ic1-col-12 ic1-col-lg-6 input">
              <ng-ui-kit-input
                formControlName="newPin"
                name="newPin"
                autocomplete="newPin"
                [placeholder]="
                  'PIN_PAGE.ACCORDION.FIRST_STEP.NEW_PIN_PLACEHOLDER'
                    | translate
                "
                type="password"
                icName="newPin"
                icId="newPin"
                [maxlength]="8"
                [OnlyNumbers]="8"
                [label]="
                  'PIN_PAGE.ACCORDION.FIRST_STEP.NEW_PIN_LABEL' | translate
                "
                [status]="
                  step1Attempted && newPin.invalid
                    ? 'error'
                    : 'informative'
                ">
              </ng-ui-kit-input>
              <app-field-validator
                *ngIf="step1Attempted"
                [field]="newPin"
                [formErrors]="formErrors"></app-field-validator>

              <div
                *ngIf="
                  formErrors?.['DIFFERENT_PIN'] &&
                  (oldPin.dirty || oldPin.touched || newPin.dirty || newPin.touched)
                "
                class="error"
                translate>
                COMMON.VALIDATORS.DIFFERENT_PIN
              </div>
            </div>

            <div class="ic1-col-12 ic1-col-lg-6">
              <ng-ui-kit-input
                formControlName="confirmPin"
                name="confirmPin"
                autocomplete="confirmPin"
                [placeholder]="
                  'PIN_PAGE.ACCORDION.FIRST_STEP.CONFIRM_NEW_PIN_PLACEHOLDER'
                    | translate
                "
                type="password"
                icName="confirmPin"
                [OnlyNumbers]="8"
                icId="confirmPin"
                [maxlength]="8"
                [label]="
                  'PIN_PAGE.ACCORDION.FIRST_STEP.CONFIRM_NEW_PIN_LABEL'
                    | translate
                "
                [status]="
                  step1Attempted && confirmPin.invalid
                    ? 'error'
                    : 'informative'
                ">
              </ng-ui-kit-input>
              <app-field-validator
                *ngIf="step1Attempted"
                [field]="confirmPin"
                [formErrors]="formErrors"></app-field-validator>

              <div
                *ngIf="
                  formErrors?.['samePassword'] &&
                  hasPinsAtMinLength() &&
                  (newPin.dirty || newPin.touched || confirmPin.dirty || confirmPin.touched)
                "
                class="error">
                <div translate="COMMON.VALIDATORS.SAME_PASSWORD"></div>
              </div>
            </div>

            <div class="ic1-col-12 buttons-container ic1-mt-16">
              <button
                type="button"
                class="ic1-btn ic1-btn-sm ic1-btn-secondary cancel-button"
                (click)="clearForm(); closeModal()"
                translate="PIN_PAGE.ACCORDION.FIRST_STEP.BTN_CANCEL"></button>

              <app-submit-button
                [label]="
                  'PIN_PAGE.ACCORDION.FIRST_STEP.BTN_CONFIRM' | translate
                "
                translate-key="PIN_PAGE.ACCORDION.FIRST_STEP.BTN_CONFIRM"
                [disabled]="loading"
                (onClick)="goToSecondStep()">
              </app-submit-button>
            </div>
          </div>
        </ng-container>
      </ng-ui-kit-accordion>
    </div>
    <!-- SECOND STEP START -->
    <div class="ic1-mt-12">
      <ng-ui-kit-accordion
        class="step2"
        [disabled]="showStep1"
        [title]="'PIN_PAGE.ACCORDION.SECOND_STEP.TITLE' | translate"
        [attr.translate-key]="'PIN_PAGE.ACCORDION.SECOND_STEP.TITLE'"
        [open]="showStep2"
        [icon]="showSuccess ? 'check' : ''"
        [step]="!showSuccess ? 2 : 0">
        <ng-container content
          ><div class="desc ic1-mb-12" translate>
            PIN_PAGE.ACCORDION.SECOND_STEP.DESC
          </div>
          <div class="ic1-col-12">
            <div class="ic1-form-group">
              <app-otp-input
                formControlName="otp"
                [error]="step2Attempted && otp.invalid"
                [startTimer]="showStep2"></app-otp-input>
            </div>
            <app-field-validator
              *ngIf="step2Attempted"
              [field]="otp"
              [formErrors]="formErrors"></app-field-validator>
          </div>
          <div class="buttons-container ic1-mt-16">
            <button
              type="button"
              (click)="goToStepOne()"
              class="ic1-btn ic1-btn-sm ic1-btn-secondary cancel-button"
              translate="PIN_PAGE.ACCORDION.SECOND_STEP.BTN_CANCEL"></button>
            <app-submit-button
              type="submit"
              [loading]="loading"
              [disabled]="loading"
              [label]="'PIN_PAGE.ACCORDION.SECOND_STEP.BTN_CONFIRM' | translate"
              translate-key="PIN_PAGE.ACCORDION.SECOND_STEP.BTN_CONFIRM"
              (onClick)="onSubmit()"></app-submit-button>
          </div>
        </ng-container>
      </ng-ui-kit-accordion>
    </div>
    </form>
  </ng-container>
</app-common-modal>
